// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__CFOM-","loader_box":"Loader_loader_box__Weus2"};